<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img :src="userImage" class="c-avatar-img" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="secondary">
      <strong style="color: white">{{ name }}</strong>
    </CDropdownHeader>
    <CDropdownItem class="d-inline-flex" @click="profileInfo()">
      <CIcon name="cil-user" class="mx-1" /> حساب کاربری
    </CDropdownItem>
    <CDropdownItem class="d-inline-flex" @click="alarmList()">
      <CIcon name="cil-bell" class="mx-1" /> هشدارها
      <CBadge color="danger" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem class="d-inline-flex">
      <CIcon name="cil-envelope-open" class="mx-1" /> پیام ها
      <CBadge color="success" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <!-- <CDropdownItem>
      <CIcon name="cil-task" /> Tasks
      <CBadge color="info" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-comment-square" /> Comments
      <CBadge color="warning" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>تنظیمات</strong>
    </CDropdownHeader>

    <CDropdownItem class="d-inline-flex" @click="editInfo()">
      <CIcon name="cil-pencil" class="mx-1" /> ویرایش اطلاعات
    </CDropdownItem>
    <CDropdownItem class="d-inline-flex" @click="changePassword()">
      <CIcon name="cil-lock-locked" class="mx-1" /> تغییر رمزعبور
    </CDropdownItem>
    <!-- <CDropdownItem class="d-inline-flex">
      <CIcon name="cil-camera" class="mx-1" /> تغییر عکس کاربری
    </CDropdownItem> -->
    <CDropdownDivider />
    <!-- <CDropdownItem>
      <CIcon name="cil-shield-alt" /> Lock Account
    </CDropdownItem> -->

    <CDropdownItem @click="louout" class="d-inline-flex">
      <CIcon name="cil-lock-locked" class="mx-1" /> خروج
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { setAuthToken } from "../../src/services/AuthService.js";
import router from "../router";
import { Values } from "../commonValues";
import axios from "axios";

export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 0,
      name: localStorage.getItem("name"),
      userImage: Values.serverIp + localStorage.getItem("image"),
    };
  },

  mounted() {},

  methods: {
    louout: function (value) {
      axios.get(Values.serverIp + "Account/Logout").then((response) => {
        console.log(response.status);
        if (response.status == 200) {
          localStorage.removeItem("token");
          localStorage.removeItem("username");
          localStorage.removeItem("name");
          localStorage.removeItem("image");
          localStorage.removeItem("changePasswordStatus");

          delete axios.defaults.headers.common["Authorization"];
          router.push({ name: "Login" });
        }
      });
      //setAuthToken("");
    },
    changePassword() {
      router.push({ name: "ChangePassword" });
    },
    editInfo(data) {
      router.push({ name: "EditInfo" });
    },
    profileInfo(data) {
      router.push({ name: "ProfileInfo" });
    },
    alarmList() {
      router.push({ name: "Alarm" });
    },
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>